import React from 'react';
import PropTypes from 'prop-types';
import CategoryToolTile from './CategoryToolTile';
import { get } from 'lodash';
import { HeadingText } from '@paypalcorp/pp-react';

const DETAILS_CTA_CONTENT_CATEGORY_KEY = 'content.categoryKey';
const DETAILS_CTA_CONTENT_LOCATION = 'content.location';

const DetailsCrossSell = props => {
  const {
    componentContent: {
      title = '',
      crossSellCategory1 = '',
      crossSellCategory2 = ''
    },
    fptiClick,
    fptiImpression,
    structuredPSData: { categories = [] },
    toolTileProps,
    experimentation = {}
  } = props;

  const { v2LayoutExp: isNewLayoutEligible } = experimentation;

  const category1 =
    categories.find(
      category =>
        get(category, DETAILS_CTA_CONTENT_CATEGORY_KEY) === crossSellCategory1
    ) || {};
  const category2 =
    categories.find(
      category =>
        get(category, DETAILS_CTA_CONTENT_CATEGORY_KEY) === crossSellCategory2
    ) || {};
  const toolsToShow = get(category1, 'featured', [])
    .slice(0, 2)
    .concat(get(category2, 'featured', []).slice(0, 2));

  const handleClickTool = ({ fptiLink, prod, PSUrl, categoryFPTI }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: categoryFPTI,
        type: 'cross_sell'
      });
      fetch(PSUrl);
    };
  };

  if (toolsToShow.length === 0) {
    return null;
  }

  if (isNewLayoutEligible) return null;

  return (
    <section className="details-cross-sell-section">
      <HeadingText level={2}  className="cross-sell-title">{title}</HeadingText>
      <div className="cross-sell-container">
        {toolsToShow.map(tool => {
          const whichCategory = categories.find(
            category =>
              get(category, DETAILS_CTA_CONTENT_CATEGORY_KEY) ===
              tool.categoryKey
          );
          const path = `/appcenter/${get(
            whichCategory,
            DETAILS_CTA_CONTENT_LOCATION,
            ''
          )}`;

          return (
            <div className="cross-sell-card" key={tool.appKey}>
              <CategoryToolTile
                fptiImpression={fptiImpression}
                tool={tool}
                toolTileProps={toolTileProps}
                path={path}
                handleClickTool={handleClickTool}
                hideFavorites={true}
                crossSellType="cross_sell"
              />
            </div>
          );
        })}
      </div>
      <div className="cross-sell-border" />
    </section>
  );
};

DetailsCrossSell.propTypes = {
  componentContent: PropTypes.object,
  fptiImpression: PropTypes.func,
  fptiClick: PropTypes.func,
  structuredPSData: PropTypes.object,
  toolTileProps: PropTypes.object,
  experimentation: PropTypes.object
};

export default DetailsCrossSell;
